import React from 'react';

import CompanyLogo from 'components/CompanyLogo';
import BasicButton from 'components/BasicButton';
import RatingPoll from 'components/RatingPoll';
import ReviewHeaderNavGuest from './components/ReviewHeaderNavGuest';

import checkmarkIcon from 'assets/images/checkmark.png';
import crossIcon from 'assets/images/cross.png';

import './styles.css';

const ReviewHeader = props => {
  const { review, actions, pageUrl } = props;
  const { onLinkClickHandler, onButtonClickHandler } = actions;

  const verifiedIcon =
    review && review.firm.Verified === 'Yes' ? checkmarkIcon : crossIcon;

  return review ? (
    <div className="review-header">
      <div className="container">
        <div className="review-header__inner">
          <div className="review-header__logo">
            <CompanyLogo
              name={review.firm.FirmName}
              logo={review.firm.Logo}
              link={pageUrl}
            />
          </div>
          <div className="review-header__content">
            <ReviewHeaderNavGuest tabs={review.firm.tabs} pageUrl={pageUrl} />
            <div className="review-header__widgets">
              <div className="review-header__widgets--row">
                <div className="review-header__rating-info">
                  <RatingPoll
                    showRating={review.firm.ShowRating}
                    rating={review.firm.Rating}
                    count={review.firm.RatingCount}
                    onLinkClickHandler={onLinkClickHandler}
                  />
                </div>

                <BasicButton
                  btnWidth={200}
                  btnHeight={40}
                  btnFontWeight={600}
                  btnText="Add a Review"
                  btnArrow={true}
                  controlFunc={onButtonClickHandler}
                />
              </div>

              <div className="review-header__additional-widgets">
                <span className="review-header__verified">
                  <img
                    className="review-header__verified-icon"
                    src={verifiedIcon}
                    alt="Verified Employer"
                  />
                  Verified Employer
                </span>
                <a href={'/contact'} className="review-header__report-link">
                  Report Misuse
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default ReviewHeader;
